import { useDuplicateGoalMutation } from 'shared/hooks/queries/use-duplicate-goal-mutation';

export const useDuplicateGoal = () => {
  const { mutateAsync } = useDuplicateGoalMutation();

  return mutateAsync;
};
